import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

export const getContractTypes = createAsyncThunk(
  "Contract/getContractTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/contract_types`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const addContractTypes = createAsyncThunk(
  "Contract/addContractTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/contract_types`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateContractTypes = createAsyncThunk(
  "Contract/updateContractTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/contract_types/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteContractTypes = createAsyncThunk(
  "Contract/deleteContractTypes",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/contract_types/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getContracts = createAsyncThunk(
  "Contract/getContracts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/contracts`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateContracts = createAsyncThunk(
  "Contract/updateContracts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/contracts/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteContracts = createAsyncThunk(
  "Contract/deleteContracts",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/contracts/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getHireLawers = createAsyncThunk(
  "Contract/getHireLawers",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/hire_lawyers`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateHireLawers = createAsyncThunk(
  "Contract/updateHireLawers",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/hire_lawyers/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteHireLawers = createAsyncThunk(
  "Contract/deleteHireLawers",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/hire_lawyers/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

const ContractSlice = createSlice({
  name: "Contract",
  initialState: {
    isContractLoading: false,
    ContractTypesArray: null,
    ContractArray: null,
    HireLawersArray: null,
  },

  extraReducers: (builder) => {
    builder
      .addCase(getContractTypes.pending, (state) => {
        state.isContractLoading = true;
      })
      .addCase(getContractTypes.fulfilled, (state, action) => {
        state.isContractLoading = false;
        state.ContractTypesArray = action.payload.data;
      })
      .addCase(getContractTypes.rejected, (state, action) => {
        state.isContractLoading = false;
      })

      .addCase(addContractTypes.pending, (state) => {
        state.isContractLoading = true;
      })
      .addCase(addContractTypes.fulfilled, (state, action) => {
        state.isContractLoading = false;
      })
      .addCase(addContractTypes.rejected, (state, action) => {
        state.isContractLoading = false;
      })

      .addCase(updateContractTypes.pending, (state) => {
        state.isContractLoading = true;
      })
      .addCase(updateContractTypes.fulfilled, (state, action) => {
        state.isContractLoading = false;
      })
      .addCase(updateContractTypes.rejected, (state, action) => {
        state.isContractLoading = false;
      })
      .addCase(deleteContractTypes.pending, (state) => {
        state.isContractLoading = true;
      })
      .addCase(deleteContractTypes.fulfilled, (state, action) => {
        state.isContractLoading = false;
        state.ContractTypesArray = state.ContractTypesArray.filter(
          (ele) => ele.id !== action.meta.arg
        );
      })
      .addCase(deleteContractTypes.rejected, (state, action) => {
        state.isContractLoading = false;
      })
      .addCase(getContracts.pending, (state) => {
        state.isContractLoading = true;
      })
      .addCase(getContracts.fulfilled, (state, action) => {
        state.isContractLoading = false;
        state.ContractArray = action.payload.data;
      })
      .addCase(getContracts.rejected, (state, action) => {
        state.isContractLoading = false;
      })

      .addCase(updateContracts.pending, (state) => {
        state.isContractLoading = true;
      })
      .addCase(updateContracts.fulfilled, (state, action) => {
        state.isContractLoading = false;
      })
      .addCase(updateContracts.rejected, (state, action) => {
        state.isContractLoading = false;
      })
      .addCase(deleteContracts.pending, (state) => {
        state.isContractLoading = true;
      })
      .addCase(deleteContracts.fulfilled, (state, action) => {
        state.isContractLoading = false;
        state.ContractArray = state.ContractArray.filter(
          (ele) => ele.id !== action.meta.arg
        );
      })
      .addCase(deleteContracts.rejected, (state, action) => {
        state.isContractLoading = false;
      })

      .addCase(getHireLawers.pending, (state) => {
        state.isContractLoading = true;
      })
      .addCase(getHireLawers.fulfilled, (state, action) => {
        state.isContractLoading = false;
        state.HireLawersArray = action.payload.data;
      })
      .addCase(getHireLawers.rejected, (state, action) => {
        state.isContractLoading = false;
      })

      .addCase(updateHireLawers.pending, (state) => {
        state.isContractLoading = true;
      })
      .addCase(updateHireLawers.fulfilled, (state, action) => {
        state.isContractLoading = false;
      })
      .addCase(updateHireLawers.rejected, (state, action) => {
        state.isContractLoading = false;
      })
      .addCase(deleteHireLawers.pending, (state) => {
        state.isContractLoading = true;
      })
      .addCase(deleteHireLawers.fulfilled, (state, action) => {
        state.isContractLoading = false;
        state.HireLawersArray = state.HireLawersArray.filter(
          (ele) => ele.id !== action.meta.arg
        );
      })
      .addCase(deleteHireLawers.rejected, (state, action) => {
        state.isContractLoading = false;
      });
  },
});

export default ContractSlice.reducer;
